export { default } from './useControlled';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/useControlled/index.js
// module id = 446
// module chunks = 25